import React from 'react';
import {Container, Row, Col } from 'react-bootstrap';


const About = (props)=>{
	return(
		<Container fluid className="about-wrapper" id={props.id}>
			<Row>
				<h2 className="row-title">About CC</h2>
			</Row>
			<Row className="about-content">
				<Col md={6} >
					Since 2004 Creative Create LLC has been bringing the excitement back into gifts, giving a special focus for DIY craft lovers. Original, gorgeous, and perfect for any gift occasion, our wide range of gifts and accessories are lovingly chosen by our talented in-house design and buying teams.
				</Col>
				<Col md={6} >
					Helping you choose the right gift along with free delivery are some of the few reasons why we can be your provider of gifts and presents for your family, friends, and colleagues. We will always go the extra mile to ensure you are happy with your purchase. So if you are looking for great and creative gifts, we will be glad to help you!

				</Col>
			</Row>
		</Container>
	);
}

export default About;